export default function _withoutIndex(iteratee) {
    return (value, index, callback) => iteratee(value, callback);
}



// WEBPACK FOOTER //
// ./~/async-es/internal/withoutIndex.js